
import { PropsWithChildren } from 'react';

export const TableActionBlock = ({ children }: PropsWithChildren) => (<div className='ted-ui-table-action-block'>{children}</div>);